var $ecc6dce838a94ce1$exports = {};
$ecc6dce838a94ce1$exports = {
    "collectionLabel": `\xd6neriler`
};


export {$ecc6dce838a94ce1$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
